import PropTypes from 'prop-types'
import { MOMENTE } from './momente.js'

export const DiscordIcon = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M20.3 4.4A19.8 19.8 0 0 0 15.4 3l-.3.5a15 15 0 0 1 4.3 2A16.4 16.4 0 0 0 4.6 5.5a15 15 0 0 1 4.3-2L8.6 3A19.8 19.8 0 0 0 3.7 4.4C.9 8.6.1 12.7.5 16.8a20 20 0 0 0 6 3l.8-1.2a13 13 0 0 1-2-1l.5-.4a14 14 0 0 0 12.3 0l.5.4a13 13 0 0 1-2 1l.8 1.2a20 20 0 0 0 6-3c.5-4.8-.8-8.9-3.1-12.4ZM8.5 14.3c-1.1 0-2-1-2-2.3s.9-2.3 2-2.3 2 1 2 2.3-.9 2.3-2 2.3Zm7 0c-1.1 0-2-1-2-2.3s.9-2.3 2-2.3 2 1 2 2.3-.9 2.3-2 2.3Z"/></svg>
)

const nr = (i) => String(i + 1).padStart(2, '0')

// textul de după un clip (numărul uriaș, titlul, fraza); la final doar butonul de Discord, mare
const MomentCap = ({ i }) => {
    const m = MOMENTE[i]
    if (m.final) {
        return (
            <div className="moment-cap final">
                <a className="btn btn-primary btn-mare" href="https://vinewood.ro/invite" target="_blank" rel="noreferrer">
                    <DiscordIcon /> Intră pe Discord
                </a>
            </div>
        )
    }
    return (
        <div className="moment-cap">
            <span className="moment-nr" aria-hidden="true">{nr(i)}</span>
            <h2>{m.titlu}</h2>
            <p>{m.text}</p>
        </div>
    )
}
MomentCap.propTypes = { i: PropTypes.number.isRequired }

export default MomentCap
